export const baseUrlYellow = process.env.REACT_APP_SERVER_URL_YELLOW;
export const baseUrlBloggers = process.env.REACT_APP_SERVER_URL_BLOGGERS;
export const baseUrlUkrChat = process.env.REACT_APP_SERVER_URL_UKR_CHAT;
